import React, { useState } from "react";
import Modal from "react-modal";
import Select from "react-select";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { useSelector, useDispatch } from "react-redux";
import {
  changePatientFlagLogic,
  setDiagnosisDataLogic,
} from "../../../../store/features/patient/patientSlice";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};

const ResetFlagModal = ({ modalIsOpen, setIsOpen, patientId }) => {
  Modal.setAppElement("#root");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.app);
  const { patientNotesLoading, flagLoading } = useSelector(
    (state) => state.patient
  );

  function closeModal() {
    if (flagLoading || patientNotesLoading) {
      notify("Please wait while the patient is being invited", "info");
      return;
    }
    setIsOpen(false);
  }

  const options = [
    { label: "Reset", value: null },
    { label: "Red Flag", value: "RED" },
    { label: "Yellow Flag", value: "YELLOW" },
  ];

  const [selectedFlag, setSelectedFlag] = useState(options[0]);
  const [commentText, setCommentText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      flag: selectedFlag.value,
      id: patientId,
      bhi_eligible: true,
    };
    if (selectedFlag?.value === "RED") {
      payload["red_flag_updated"] = new Date();
    }
    dispatch(changePatientFlagLogic(payload));
    dispatch(
      setDiagnosisDataLogic({
        diagnosis: `flag change to ${selectedFlag?.value?.toLowerCase()}`,
        notes: commentText,
        patient: patientId.toString(),
        added_by: user?.id,
      })
    );
    setSelectedFlag(options[0]);
    setCommentText("");
    closeModal();
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="w-100 pt-2 d-flex justify-content-start">
            <h3 className="primary-text-blue">Change Patient Flag</h3>
          </div>
          <form className="container-fluid w-100" onSubmit={handleSubmit}>
            <div className="form-group pb-3 w-100">
              <label>Change flag to *</label>
              <Select
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "0px",
                    borderBottom: "1px solid #94A3B8",
                    borderRadius: "0px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                placeholder="Select Flag"
                classNamePrefix="select"
                name="flag"
                options={options}
                value={selectedFlag}
                isDisabled={flagLoading || patientNotesLoading}
                onChange={(e) => {
                  setSelectedFlag(e);
                }}
              />
            </div>
            <div className="form-group pb-3 w-100">
              <label>Comments</label>
              <textarea
                disabled={flagLoading || patientNotesLoading}
                className="form-control"
                value={commentText}
                onInput={(e) => {
                  setCommentText(e.target.value);
                }}
                rows={5}
                style={{ resize: "none" }}
              ></textarea>
            </div>

            <div
              style={{ gap: "5%" }}
              className="d-flex justify-content-end py-3 container-fluid w-100"
            >
              <button className="btn alternative-btn" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="primary-btn"
                type="submit"
                disabled={flagLoading || patientNotesLoading}
              >
                Confirm
              </button>
            </div>
          </form>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default ResetFlagModal;
